
import { mapGetters } from 'vuex'
import menuData from '../../data/menu.json';
// import menuUSData from '../../data/menuUS.json';
export default {
 data() {
    return {
      showSkeleton: true, // skeleton is shown initially
    };
  },
  computed:{
    ...mapGetters({
      // region: 'user/region',
      detectedRegion: 'geolocation/region',
      regionReady: 'geolocation/isRegionReady',
      userRegion: 'user/region',
      currentLabel: 'cart/getPriceLabel',
      detectedCountry: 'geolocation/detectedCountry',
    }),
    activeFlag(){
      const fl = this.$nuxt.$options.filters.flagFromLabel(this.currentLabel,this.detectedCountry)
      console.log('MENU FLAG',fl)
      return fl
    },
    region(){
      console.log('MENU REGIONS',this.userRegion, this.detectedRegion)
      return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
    },
   menu(){
  //  if(this.region==='en')
    return menuData
  //  else
  //  return menuUSData
    }
  },
  mounted() {
      this.showSkeleton = false; // hide skeleton immediately on client mount
  },
}
